import { CourseDef } from '../../../../types';
import L2084300 from './2084300';
import L2084302 from './2084302';
import L2084303 from './2084303';
// import L5234454 from './5234454';
import L5234455 from './5234455';

export const estrategiasDeMercadoAberto: CourseDef = {
  courseTitle: 'ESTRATÉGIAS DE MERCADO ABERTO',
  lessons: [L2084300, L2084302, L2084303, 
    // L5234454, 
    L5234455],
};

